import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentEventsHobbiesChessRook: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.905 25.9h1.52v3.05h-1.52Zm-19.81 3.05h19.81v1.53H6.095Zm15.24-9.14h1.52v1.52h-1.52Zm-1.53-1.52h1.53v1.52h-1.53Zm-6.09 0v-7.62h4.57v7.62h1.52v-7.62h3.05V9.14h1.53V1.52h-3.05v1.53h-3.05V1.52h-4.57v1.53h-3.05V1.52h-3.05v7.62h1.53v1.53H12.2v7.62ZM12.2 6.1h7.61v1.52H12.2Zm-1.535 12.19h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.52h-1.52Zm0 4.57v-3.05h-1.53v3.05h-1.52v1.52h19.81v-1.52h-1.52v-3.05h-1.53v3.05zm-4.57 1.52h1.52v3.05h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default entertainmentEventsHobbiesChessRook
